module.exports = __webpack_public_path__ + "static/media/down-arrow.d348d5b0.svg";